/* eslint-disable no-console */

import Vue from 'vue'
import '@/@fake-db/db'
import { ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

// 3RD PARTY LIBRARIES
import '@/libs/abilityPlugin'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alert-2'
import '@/libs/google-maps'
import '@/libs/stripes'
import '@/libs/vee-validate'
import '@/libs/vue-select'
import '@/libs/flat-pickr'
import '@/libs/boostrap-vue'
import '@/libs/custom-components'
import '@/libs/font-awesome-icon'
import '@/libs/vue-font-awesome-picker'
import '@/libs/recaptcha'

// PLUGINS
import '@/plugins/moment'

// FILTERS
import '@/filters/filters'

// DIRECTIVES
import '@/directives/vue-ripple-directive'
import '@/directives/b-tooltip-directive'
import '@/directives/b-toggle-directive'
import '@/directives/scroll-to-directive'

// MAJOR LIBRARIES
import i18n from '@/libs/i18n'
import ability from '@/libs/ability'

// LEGACY LIBRARIES
import store from '@/store/store'
import router from '@/router/router'

import App from './App.vue'

import './helpers/alert'

// PROTOTYPE
import '@/prototype/lodash'
import '@/prototype/getMeasurementUnitItn'

// BSV Plugin Registration
Vue.use(ModalPlugin) // Useful for $BVModal

// Composition API
Vue.use(VueCompositionAPI)

// ERRORS LOGING AND TRACKING
if (process.env.NODE_ENV !== 'production') {
  Vue.config.errorHandler = err => {
    console.error(err)
  }

  Vue.config.productionTip = true
} else {
  Vue.config.productionTip = false
}

if (process.env.VUE_APP_SENTRY_DSN && process.env.VUE_APP_SENTRY_ENV) {
  Sentry.init({
    Vue,
    environment: process.env.VUE_APP_SENTRY_ENV,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    replaysSessionSampleRate: process.env.VUE_APP_REPLAY_SENTRY_SESSION_SAMPLE_RATE,
    replaysOnErrorSampleRate: process.env.VUE_APP_REPLAY_SENTRY_ON_ERROR_SAMPLE_RATE,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: [process.env.VUE_APP_SENTRY_PROPAGATION_TARGET, /^\//],
      }),
      new Sentry.Replay({
        maskAllText: process.env.VUE_APP_SENTRY_MASK_ALL_TEXT,
        blockAllMedia: process.env.VUE_APP_SENTRY_BLOCK_ALL_MEDIA,
      }),
    ],
    logErrors: true,
    tracesSampleRate: process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE,
    trackComponents: true,
    timeout: 500,
    hooks: ['activate', 'create', 'destroy', 'mount', 'update'],
    ignoreErrors: ['NavigationDuplicated'],
    release: process.env.VUE_APP_SENTRY_RELEASE,
  })
}

// SCSS
require('@core/scss/core.scss')
require('@/assets/scss/style.scss')

new Vue({
  ability,
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
